import React from 'react';
import NumberGame from './NumberGame';

function App() {
  return (
    <div className="App">
      <NumberGame />
    </div>
  );
}

export default App;
